import { c as e } from "react/compiler-runtime";
import { InteractionRequiredAuthError as t, InteractionType as n, LogLevel as r, createStandardPublicClientApplication as i } from "@azure/msal-browser";
import { MsalAuthenticationTemplate as a, MsalProvider as o, useMsal as s } from "@azure/msal-react";
import { createContext as c, useEffect as l, useState as u } from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
//#region src/config/Config.ts
var p = {
	Local: "local",
	Dev: "dev",
	Stg: "stg",
	Prd: "prd"
}, m = (e) => {
	let t = new URL(e).hostname;
	return t === "localhost" || t === "127.0.0.1" ? p.Local : t.startsWith("dev.") ? p.Dev : t.startsWith("stg.") ? p.Stg : p.Prd;
}, h = (e) => e !== p.Prd, g = c({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	logout: async () => {
		throw Error("logout not initialized");
	},
	userAccount: {}
}), _ = async (e, n, r) => {
	let i = {
		scopes: r,
		account: e
	};
	try {
		return (await n.acquireTokenSilent(i)).accessToken;
	} catch (e) {
		throw e instanceof t && await n.acquireTokenRedirect(i), e;
	}
}, v = (t) => {
	let n = e(26), { children: r, scopes: i } = t, { accounts: a, instance: o } = s(), c;
	n[0] !== a || n[1] !== o ? (c = o.getActiveAccount() ?? (a.length === 1 ? a[0] : void 0), n[0] = a, n[1] = o, n[2] = c) : c = n[2];
	let l = c;
	if (!l) throw Error("Authenticated user account is missing");
	let u = l.idTokenClaims, f = u?.given_name, p = u?.family_name, m = `${u?.given_name} ${u?.family_name}`, h = u?.user, v = u?.userType, y = u?.agent, b = u?.agency, x = u?.roles, S;
	n[3] !== f || n[4] !== p || n[5] !== m || n[6] !== h || n[7] !== v || n[8] !== y || n[9] !== b || n[10] !== x ? (S = {
		firstName: f,
		lastName: p,
		fullName: m,
		user: h,
		userType: v,
		agent: y,
		agency: b,
		roles: x
	}, n[3] = f, n[4] = p, n[5] = m, n[6] = h, n[7] = v, n[8] = y, n[9] = b, n[10] = x, n[11] = S) : S = n[11];
	let C = S, w;
	n[12] !== l || n[13] !== o || n[14] !== i ? (w = () => _(l, o, i), n[12] = l, n[13] = o, n[14] = i, n[15] = w) : w = n[15];
	let T;
	n[16] !== l || n[17] !== o ? (T = (e) => o.logoutRedirect({
		account: l,
		postLogoutRedirectUri: e
	}), n[16] = l, n[17] = o, n[18] = T) : T = n[18];
	let E;
	n[19] !== w || n[20] !== T || n[21] !== C ? (E = {
		getAuthToken: w,
		logout: T,
		userAccount: C
	}, n[19] = w, n[20] = T, n[21] = C, n[22] = E) : E = n[22];
	let D;
	return n[23] !== r || n[24] !== E ? (D = /* @__PURE__ */ d(g.Provider, {
		value: E,
		children: r
	}), n[23] = r, n[24] = E, n[25] = D) : D = n[25], D;
}, y = {
	alignContent: "center",
	boxSizing: "border-box",
	display: "grid",
	gap: "1rem",
	justifyItems: "center",
	minHeight: "100vh",
	padding: "2rem",
	textAlign: "center"
}, b = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ d("div", {
		role: "status",
		"aria-live": "polite",
		style: y,
		children: "Signing in..."
	}), t[0] = n) : n = t[0], n;
}, x = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ f("div", {
		role: "alert",
		style: y,
		children: [/* @__PURE__ */ d("p", { children: "Unable to sign in" }), /* @__PURE__ */ d("button", {
			type: "button",
			onClick: D,
			children: "Try again"
		})]
	}), t[0] = n) : n = t[0], n;
}, S = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: i, envSigninPrefix: a, authEnableLogs: o }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!i) throw Error("authSignupSigninPolicyId is not set");
	if (!a) throw Error("envSigninPrefix is not set");
	let s = o === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${i}`,
			knownAuthorities: [t],
			redirectUri: a
		},
		cache: { cacheLocation: "localStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (s && !n) switch (e) {
				case r.Error:
					console.error(t);
					return;
				case r.Info:
					console.info(t);
					return;
				case r.Verbose:
					console.debug(t);
					return;
				case r.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, C = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => ({
	firstName: "Local",
	lastName: "User",
	fullName: "Local User",
	user: e,
	userType: t,
	agent: e,
	agency: n,
	roles: r?.split(",").map((e) => e.trim()).filter(Boolean)
}), w = (t) => {
	let n = e(7), { children: r, apiConfig: i } = t, a;
	n[0] === i ? a = n[1] : (a = C(i), n[0] = i, n[1] = a);
	let o;
	n[2] === a ? o = n[3] : (o = {
		getAuthToken: O,
		logout: k,
		userAccount: a
	}, n[2] = a, n[3] = o);
	let s;
	return n[4] !== r || n[5] !== o ? (s = /* @__PURE__ */ d(g.Provider, {
		value: o,
		children: r
	}), n[4] = r, n[5] = o, n[6] = s) : s = n[6], s;
}, T = ({ children: e, apiConfig: t }) => {
	let [r, s] = u(), [c, f] = u(!1);
	return l(() => {
		let e = (e) => {
			console.error("Failed to initialize authentication", e), f(!0);
		};
		try {
			if (!t.authAppUri) throw Error("authAppUri is not set");
			let n = { scopes: [`${t.authAppUri}/openid`] };
			i(S(t)).then((e) => s({
				instance: e,
				authenticationRequest: n
			}), e);
		} catch (t) {
			e(t);
		}
	}, [t]), c ? /* @__PURE__ */ d(x, {}) : r ? /* @__PURE__ */ d(o, {
		instance: r.instance,
		children: /* @__PURE__ */ d(a, {
			interactionType: n.Redirect,
			authenticationRequest: r.authenticationRequest,
			loadingComponent: b,
			errorComponent: x,
			children: /* @__PURE__ */ d(v, {
				scopes: r.authenticationRequest.scopes,
				children: e
			})
		})
	}) : /* @__PURE__ */ d(b, {});
}, E = (t) => {
	let n = e(6), { children: r, apiConfig: i } = t;
	if (i.devMode && i.userIdClaim && i.userTypeClaim) {
		let e;
		return n[0] !== i || n[1] !== r ? (e = /* @__PURE__ */ d(w, {
			apiConfig: i,
			children: r
		}), n[0] = i, n[1] = r, n[2] = e) : e = n[2], e;
	}
	let a;
	return n[3] !== i || n[4] !== r ? (a = /* @__PURE__ */ d(T, {
		apiConfig: i,
		children: r
	}), n[3] = i, n[4] = r, n[5] = a) : a = n[5], a;
};
function D() {
	return window.location.reload();
}
async function O() {
	return "local-dev-auth";
}
async function k(e) {
	window.location.assign(e);
}
//#endregion
//#region src/api/AuthorizedApiBase.ts
var A = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => {
	let i = {};
	return e !== void 0 && (i["x-claim-userId"] = e), t !== void 0 && (i["x-claim-userType"] = t), n !== void 0 && (i["x-claim-agency"] = n), r !== void 0 && (i["x-claim-roles"] = r), i;
}, j = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = A(t);
	};
	async transformResult(e, t, n) {
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		return t.status >= 200 && t.status < 300 && r.includes("application/json") && typeof i == "object" && i ? i : await Promise.resolve(n(t));
	}
}, M = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({});
//#endregion
export { M as AgentRole, E as AgxAuth, p as AgxEnvironments, g as AuthContext, j as AuthorizedApiBase, N as StaffRole, h as isNonProductionEnvironment, m as resolveAgxEnvironment };

//# sourceMappingURL=index.js.map